import styled from 'styled-components'

import { Flex } from '../Flex'
import { themeColor } from '../theme'

const BorderedWrapper = styled(Flex)`
  border: 1px solid ${themeColor('borderPrimary')};
  border-radius: 4px;
  background-color: ${themeColor('white')};
  z-index: 5;
  position: relative;
`

export default BorderedWrapper
